import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideStore } from '@ngxs/store';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';
import { withNgxsFormPlugin } from '@ngxs/form-plugin';

import { environment } from '../environments/environment.prod';

import { CONSTANTS } from './utils/constants';
import { routes } from './app.routes';
import { apiInterceptor } from './states/api.interceptor';
import { AuthService } from './states/auth/auth.service';
import { AuthState } from './states/auth/auth.state';
import { SportState } from './states/sport/sport.state';
import { EaTitleStrategy } from './title-strategy';
import { EventService } from './states/event/event.service';
import { EventState } from './states/event/event.state';
import { GameService } from './states/game/game.service';
import { GameState } from './states/game/game.state';
import { RosterService } from './states/roster/roster.service';
import { RosterState } from './states/roster/roster.state';
import { TeamService } from './states/team/team.service';
import { TeamState } from './states/team/team.state';
import { VenueState } from './states/venue/venue.state';
import { HotkeyService } from './services/hotkey/hotkey.service';
import { EventTreeState } from './states/event-tree/event-tree.state';
import { ApplicationState } from './states/application/application.state';
import { VenueService } from './states/venue/venue.service';
import { SportService } from './states/sport/sport.service';

import { QueryParamsService } from 'src/services/query-params/query-params.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideHttpClient(
            withInterceptors([apiInterceptor])
        ),
        provideRouter(routes),
        importProvidersFrom(OverlayModule),
        provideStore(
            [
                AuthState,
                SportState,
                ApplicationState,
                GameState,
                TeamState,
                RosterState,
                EventState,
                EventTreeState,
                VenueState
            ], {
                developmentMode: !environment.production,
                selectorOptions: {
                    suppressErrors: false,
                    injectContainerState: false,
                }
            },
            withNgxsRouterPlugin(),
            withNgxsFormPlugin()
        ),
        provideTranslateService({
            fallbackLang: CONSTANTS.defaultLocale,
            lang: CONSTANTS.defaultLocale,
            loader: provideTranslateHttpLoader({
                prefix: '/assets/i18n/',
                suffix: '.json'
            })
        }),
        {
            provide: TitleStrategy, useClass: EaTitleStrategy
        },
        provideAppInitializer(() => {
            // instantiate the query params service here so that it will run right away
            inject(QueryParamsService);
        }),
        AuthService,
        GameService,
        TeamService,
        RosterService,
        EventService,
        HotkeyService,
        VenueService,
        SportService
    ]
};
